<template>
  <Modal c-class="bg-light3 bg-important" classs="gf_schedule-publish" @cancel="close">
    <template #header>
      <h3 class="typo-h18 typo-medium text-light-high typo-lh150">Schedule Publish</h3>
    </template>
    <template #default>
      <div class="row mb-2">
        <div class="col-12">
          <section class="notibox notibox-info">
            <h2 class="typo-p14 typo-regular">Set a specific time for page publishing for the optimal impact</h2>
          </section>
        </div>
      </div>
      <div class="row pb-3">
        <div class="date-column col-12">
          <DateTimePicker
            :value="publishAt"
            :label="publishOnText"
            :active="activePublish"
            @toggle="togglePublishAt"
            @change-date-time="changeDatePicker" />
          <p
            v-if="errors.publish && errors.publish.length"
            class="mt-half text-danger typo-p12 typo-regular error-text m-0">
            {{ errors.publish }}
          </p>
        </div>
        <!-- <div class="date-column col" v-if="isProductCollectionHome">
          <DateTimePicker label="Revert on" :min="publishAt" v-model="revertAt" :active="activeRevert" @toggle="toggleRevertAt" :toggleDisabled="!activePublish" />
          <p class="m-0 mt-half text-danger typo-p12 typo-regular error-text" v-if="errors.revert && errors.revert.length">{{ errors.revert }}</p>
        </div> -->
      </div>

      <template v-if="isProductCollectionHome">
        <div v-if="activePublish" class="row mt-1">
          <div class="date-column col-12 mb-1">
            <div v-if="type == 'index'" class="d-flex align-items-center mb-half">
              <h3 class="typo-h15 typo-regular text-light-high">Make current template "default" when published?</h3>
              <Toggler class="ml-2" :model-value="true" :without-style-disabled="true" disabled />
            </div>
            <div v-else class="d-flex align-items-center mb-half">
              <h3 class="typo-h15 typo-regular text-light-high clickable" @click="toggleWillMakeDefault">
                Make current template "default" when published?
              </h3>
              <Toggler v-model="willMakeDefault" class="ml-2" />
            </div>
          </div>
          <!-- <div class="date-column col-6" v-if="isProductCollectionHome && activeRevert">
            <h3 class="typo-h15 typo-regular text-light-high mb-half">Revert to template:</h3>
            <SelectTemplate v-model:value="template" :options="templateList" :excludes="excludeList" />
          </div> -->
        </div>
        <div v-else class="row mt-1">
          <div class="date-column col-12 mb-1">
            <div class="d-flex align-items-center mb-half min-h-18"></div>
          </div>
        </div>
      </template>
    </template>
    <template #footer>
      <div class="btn-group">
        <button class="btn btn-outline btn-default gf_schedule-publish--close ml-auto mr-1 px-4" @click="close">
          Cancel
        </button>
        <ProcessButton
          v-model:status="btnStatus"
          class="btn-default px-4"
          type="submit"
          default="btn-primary"
          :disabled="disableSaveBtn"
          @click="doSchedule">
          <template #loading>Applying</template>
          <template #success>Success</template>
          <template #error>Error</template>
          <template #default>Apply</template>
        </ProcessButton>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DateTimePicker from './DateTimePicker.vue';
import initProcessButton from '@/mixins/processButton';
import { mapActions, mapGetters, mapState } from 'vuex';
import { actions, getters } from '@/store/page/types';
import type { BaseEventParam, CreateEventParam } from '@/store/app/types';
import { actions as appActions } from '@/store/app/types';
import JsDate from '@/plugins/timeago';
import HELPER from '@/app/utils/HELPER';
import errorHandle from '@/mixins/errorHandle.js';
import Modal from '@/core/components/base/Modal.vue';
import Toggler from '@/core/components/base/Toggler.vue';
import ProcessButton from '@/core/components/ProcessButton.vue';
import { emitTrackCompleteRateEvent, isLandingPage } from '@/modules/gem-meter';

// import SelectTemplate from "./SelectTemplate.vue";
// import { State as AppState } from "@/store/app/state";

export default defineComponent({
  name: 'ScheduleModal',
  components: {
    // SelectTemplate
    DateTimePicker,
    Modal,
    Toggler,
    ProcessButton,
  },
  mixins: [initProcessButton, errorHandle()],
  props: {
    templateId: {
      type: [String, Number],
      default: -1,
    },
    publish: {
      type: [Date, Number, String],
      default: '',
    },
    revert: {
      type: [Date, Number, String],
      default: '',
    },
    makeDefault: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'index',
    },
    gId: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    publishAt: '',
    revertAt: '',
    activePublish: false,
    activeRevert: false,
    template: -1,
    errorPublish: '',
    errorRevert: '',
    willMakeDefault: false,
  }),
  computed: {
    ...mapState('app', {
      pageInfo: (state) => (state as any).pageInfo,
    }),
    ...mapGetters('page', {
      // subPages: getters.SORTED_PAGES,
      // articlePages: getters.SORTED_ARTICLE,
      homePages: getters.SORTED_INDEX,
      productPages: getters.SORTED_PRODUCT,
      collectionPages: getters.SORTED_COLLECTION,
    }),
    templateList() {
      switch (this.type) {
        // case "page": {
        //   return this.subPages;
        // }
        // case "article": {
        //   return this.articlePages;
        // }
        case 'index': {
          return this.homePages;
        }
        case 'product': {
          return this.productPages;
        }
        case 'collection': {
          return this.collectionPages;
        }
        default: {
          return [];
        }
      }
    },
    excludeList() {
      const output: any[] = [];
      // if (this.templateId) {
      //   output.push(this.templateId);
      // }
      // eslint-disable-next-line camelcase
      if (this.pageInfo?.page?.g_id) {
        const id = Number(this.pageInfo.page.g_id);
        if (!isNaN(id)) {
          output.push(id);
        }
      }
      return output;
    },
    isProductCollectionHome() {
      return ['product', 'index', 'collection'].includes(this.type);
    },
    disableSaveBtn() {
      if (this.activePublish && !this.publishAt) {
        return true;
      }
      if (this.activeRevert && !this.revertAt) {
        return true;
      }
      return false;
    },
    errors() {
      const output = {
        publish: '',
        revert: '',
      };

      if (this.activePublish && !this.publishAt) {
        output.publish = 'Please choose a date to publish';
      }
      if (this.errorPublish?.length) {
        output.publish = this.errorPublish;
      }

      if (this.activeRevert && !this.revertAt) {
        output.revert = 'Please choose a date to revert';
      }
      if (this.errorRevert?.length) {
        output.revert = this.errorRevert;
      }

      return output;
    },
    publishOnText() {
      let text = 'Publish on';
      if (this.publishAt) {
        const date = new JsDate(this.publishAt);
        text += ` <em class="time-value">${date.format('HH:mm dd MMM yyyy', false)}</em>`;
      }
      return text;
    },
  },
  mounted() {
    if (this.type && this.type.length) {
      this.fetchPages({ type: this.type });
    }
    this.initData();
  },
  methods: {
    ...mapActions('page', {
      fetchPages: actions.FETCH_PAGES,
    }),
    ...mapActions('app', {
      createEvent: appActions.CREATE_PAGE_EVENT,
      // updateEvent: appActions.UPDATE_PAGE_EVENT,
      deleteEvent: appActions.CANCEL_PAGE_EVENT,
    }),
    initData() {
      // this.revertAt = (this.revert as string) || "";
      // this.template = (this.templateId as number) || -1;
      this.willMakeDefault = this.makeDefault;
      this.publishAt = (this.publish as string) || '';
      if (this.publishAt) {
        this.activePublish = true;
      }
    },
    close() {
      this.$emit('cancel');
    },

    doSchedule() {
      if (this.disableSaveBtn) {
        return;
      }

      if (this.activePublish) {
        const today = new Date();
        const incoming = new Date(this.publishAt);

        if (Math.round((incoming.getTime() - today.getTime()) / 1000) <= 0) {
          this.errorPublish = 'Schedule time must not be in the past';
          return;
        }
      }

      this.activeLoading();
      this.apiFlowControl()
        .then((res: any) => {
          this.activeSuccess();
          // ===== GemMeter Feature ===== //
          if (isLandingPage()) {
            emitTrackCompleteRateEvent('schedule');
            setTimeout(() => {
              this.close();
            }, 1000);
          }
          // =========================== /
        })
        .catch((err: any) => {
          // eslint-disable-next-line no-console
          console.error(err);
          const errorType = this.getErrorMessage(err);
          const errMsg = errorType == 'yourPlanHaveNoRightToAccess' ? '' : errorType;
          HELPER.showNotify(errMsg, 'error');
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    },
    // magic chua' nek :3
    apiFlowControl() {
      const params: BaseEventParam = {
        type: `template-${this.type}`,
        event: 'schedule_publish',
        id: this.gId,
        fields: {
          eventAt: 'event_at',
        },
      };
      const hasMakeDefault = !['page', 'article'].includes(this.type);
      if (hasMakeDefault) {
        params.fields.makeDefault = 'make_default';
      }
      if (this.activePublish) {
        const paramCreate: CreateEventParam = {
          ...params,
          body: {},
        };
        paramCreate.body.eventAt = this.publishAt;
        if (hasMakeDefault) {
          paramCreate.body.makeDefault = this.willMakeDefault;
          if (this.type == 'index') {
            paramCreate.body.makeDefault = true;
          }
        }
        return this.createEvent(paramCreate);
      } else {
        return this.deleteEvent(params);
      }
    },

    togglePublishAt(val: boolean) {
      this.activePublish = val;
      if (!val) {
        this.activeRevert = false;
      }
    },
    toggleRevertAt(val: boolean) {
      this.activeRevert = val;
    },
    toggleWillMakeDefault() {
      this.willMakeDefault = !this.willMakeDefault;
    },
    changeDatePicker(newVal: string) {
      this.publishAt = newVal;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gp_modal {
  :deep(.gp_modal-container) {
    width: 28vw;
    max-width: 768px;
    // &_body {
    //   min-height: 497px;
    // }
  }
}
.date-column {
  min-width: 360px;
  position: relative;

  .error-text {
    position: absolute;
  }
}

.datetime-picker-bound {
  :deep(.time-value) {
    font-size: 0.8em;
    color: $cGreen;
  }
}

.notibox {
  $gutter: 10px;
  padding: $gutter;
  &-info {
    background: rgba($mono3, 0.15);
    color: $text-light-high;
    position: relative;
    padding-left: $gutter * 2 + 14px;
    &:before {
      content: '\e917';
      font-family: 'gemicon';
      speak: never;
      font-style: normal;
      font-weight: 500;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      font-size: 14px;
      color: $mono3;
      position: absolute;
      top: $gutter + 2px;
      left: $gutter;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
}

.min-h-18 {
  min-height: 18px;
}

@media screen and (max-width: 1655px) {
  .min-h-18 {
    min-height: 34px;
  }
}
</style>
